import { render, staticRenderFns } from "./instockCategory.vue?vue&type=template&id=2fe18055&scoped=true&"
import script from "./instockCategory.vue?vue&type=script&lang=js&"
export * from "./instockCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe18055",
  null
  
)

export default component.exports